// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importuj menu z {{platform}}',
    copy: 'Skopiuj menu z {{restaurant}}',
    data: 'Utwórz menu odczytane przez Amigo',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Utwórz {{categories}} i {{dishes}}',
    from: {
      file: 'Amigo odczytał to z Twojego pliku',
      chat: 'Amigo odczytał to z naszej rozmowy',
    },
    summary: 'Tworzy {{categories}} i {{dishes}}. Sprawdź każde danie wraz z ceną na poniższej liście.',
    price: 'Cena',
    tax_category: 'Kategoria podatkowa',
    no_price: 'Brak ceny',
    default_tax: 'Twoja standardowa stawka',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Tworzenie: {{categories}} i {{dishes}}…',
    done: 'Menu zostało utworzone: {{categories}}, {{dishes}} i {{option_groups}} są w menu restauracji {{restaurant}}',
    done_plain: 'Menu zostało utworzone',
  },
  waiting: 'Oczekuje na zatwierdzenie',
  labels: {
    from: 'Z',
    to: 'Do',
    menu: 'Menu',
    brings_over: 'Przenosi',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Menu, które Amigo odczytał · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, jedyna lokalizacja',
    brand_one: 'Menu marki {{name}}, jej jedyny lokal',
    brand_few: 'Menu marki {{name}}, wszystkie lokalizacje: {{count}}',
    brand_many: 'Menu marki {{name}}, wszystkie lokalizacje: {{count}}',
    brand_other: 'Menu marki {{name}}, wszystkie lokalizacje: {{count}}',
  },
  menu: {
    empty: 'Puste, więc stanie się menu',
    adds: 'Dodaje do bieżącego menu ({{size}}). Dania o tej samej nazwie są aktualizowane; nic nie jest usuwane.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} kategoria',
    categories_few: '{{count}} kategorie',
    categories_many: '{{count}} kategorii',
    categories_other: '{{count}} kategorii',
    dishes_one: '{{count}} danie',
    dishes_few: '{{count}} dania',
    dishes_many: '{{count}} dań',
    dishes_other: '{{count}} dań',
    option_groups_one: '{{count}} grupa opcji',
    option_groups_few: '{{count}} grupy opcji',
    option_groups_many: '{{count}} grup opcji',
    option_groups_other: '{{count}} grupy opcji',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Wszystko, bez zmian',
    categories: 'kategorie',
    dishes: 'dania',
    descriptions: 'opisy',
    prices: 'ceny',
    option_groups: 'grupy opcji',
    photos: 'zdjęcia',
    where: {
      allergens_nutrition: 'alergeny i wartości odżywcze, jeśli {{platform}} je udostępnia',
      allergens: 'alergeny, jeśli {{platform}} je udostępnia',
      nutrition: 'wartości odżywcze, jeśli {{platform}} je udostępnia',
    },
  },
  not_live: '{{restaurant}} jeszcze nie działa: goście widzą menu pod linkiem do sklepu, ale nie mogą zamawiać.',
  buttons: {
    import: 'Importuj',
    copy: 'Kopiuj',
    cancel: 'Anuluj',
  },
  hint: 'Albo odpowiedz poniżej, aby coś zmienić.',
  action_failed: 'Nie udało się, więc nic się nie zmieniło. Spróbuj ponownie za chwilę.',
  importing: {
    title: {
      import: 'Importowanie z {{platform}}…',
      copy: 'Kopiowanie z {{restaurant}}…',
    },
    started: 'Rozpoczęto {{time}}',
    queued: 'Uruchamianie…',
    hint: 'To może potrwać kilka minut. Możesz zamknąć panel lub pracować dalej; wynik opublikuję tutaj.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'Import z {{platform}} zakończony: {{categories}}, {{dishes}} i {{option_groups}} są w menu lokalu {{restaurant}}',
      copy: 'Kopiowanie zakończone: {{categories}}, {{dishes}} i {{option_groups}} są w menu',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'Import z {{platform}} zakończony',
      copy: 'Kopiowanie zakończone',
    },
    finished: 'Zakończono {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Otwórz {{page}}',
  },
  failed: {
    title: {
      import: 'Nie udało się zaimportować: {{reason}}',
      copy: 'Nie udało się skopiować: {{reason}}',
    },
    title_plain: {
      import: 'Nie udało się zaimportować',
      copy: 'Nie udało się skopiować',
    },
    nothing: {
      import: 'Nic nie zaimportowano.',
      copy: 'Nic nie skopiowano.',
    },
    what_to_try: 'Co spróbować:',
    retry: 'Spróbuj ponownie',
    reasons: {
      listing_not_found: {
        title: 'nie znaleziono oferty',
        text: '{{platform}} nie ma restauracji pod tym linkiem. Nic nie zaimportowano.',
        try: 'Otwórz link w przeglądarce, aby sprawdzić, czy pokazuje menu restauracji, a potem wyślij go ponownie.',
      },
      listing_not_supported: {
        title: 'oferta nieobsługiwana',
        text: 'To strona sieci na {{platform}}, a nie menu jednej restauracji, więc nie mogę jej zaimportować. Nic nie zaimportowano.',
        try: 'Wyślij link do strony menu samej restauracji na {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} nie powiodło się',
        text: '{{platform}} nie odpowiedziało, więc nic nie zaimportowano.',
        try: 'Spróbuj ponownie za kilka minut.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'kopiowanie nie powiodło się',
        text: 'Kopiowanie nie zostało ukończone, więc nic nie skopiowano.',
        try: 'Spróbuj ponownie za kilka minut.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'waluta się nie zgadza',
        text: 'Oferta jest w walucie {{listing}}, ale {{restaurant}} używa {{currency}}. Nic nie zaimportowano.',
        try: 'Wyślij ofertę w walucie {{currency}} lub najpierw sprawdź walutę restauracji w {{page}}.',
        text_other: 'Oferta jest w innej walucie niż {{restaurant}}. Nic nie zaimportowano.',
        try_other: 'Wyślij ofertę w walucie restauracji lub najpierw sprawdź jej walutę w {{page}}.',
      },
      link_paused: {
        title: 'link wstrzymany',
        text: 'Ten link zawiódł 3 razy z rzędu, więc importy z niego są wstrzymane do {{time}}. Nic nie zaimportowano.',
        text_no_until:
          'Ten link zawiódł 3 razy z rzędu, więc importy z niego są na razie wstrzymane. Nic nie zaimportowano.',
        try: 'Wyślij link z innej platformy lub skopiuj menu z innej restauracji.',
      },
    },
  },
  stopped: {
    title: 'Zatrzymano: {{restaurant}} została uruchomiona',
    nothing: {
      import: 'Nic nie zaimportowano',
      copy: 'Nic nie skopiowano',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Anulowano',
    expired: 'Wygasło',
    replaced: 'Zastąpiono',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Zatwierdzono.',
    cancelled: 'Anulowano.',
    retried: 'Spróbowano ponownie.',
  },
};
